package com.solevo.dist.di

import org.koin.core.context.GlobalContext
import org.koin.core.context.startKoin

/**
 * Created by Ilija Vucetic on 3.9.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
object DI {
    private var started = false
    fun start() {
        if (!started && GlobalContext.getOrNull() == null) {
            startKoin { modules(appModule) }
            started = true
        }
    }
}